// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.adminSidebar_sidebar_container__G9HCC {
  width: 100%;
  max-width: 280px;
  height: 100vh;
  background-color: var(--main-bg-color);
  overflow-y: scroll;
  transition: width 0.3s ease-in-out;
}
.adminSidebar_sidebar_container__G9HCC::-webkit-scrollbar {
  display: none;
}
.adminSidebar_sidebar_container__G9HCC .adminSidebar_logo_wrap__sckIl {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 24px;
  position: sticky;
  top: 0;
  background: var(--main-bg-color);
}
.adminSidebar_sidebar_container__G9HCC .adminSidebar_logo_wrap__sckIl img {
  width: 120px;
  background: var(--main-bg-color);
  transition: width 0.3s ease-in-out;
}
.adminSidebar_sidebar_container__G9HCC .adminSidebar_logo_wrap__sckIl .adminSidebar_logo_title__3v9zR {
  font-weight: 700;
  color: var(--primary-color);
  font-size: 18px;
  line-height: 1;
  text-transform: uppercase;
}
@media (max-width: 1440px) {
  .adminSidebar_sidebar_container__G9HCC .adminSidebar_logo_wrap__sckIl {
    padding: 0 24px;
  }
  .adminSidebar_sidebar_container__G9HCC .adminSidebar_logo_wrap__sckIl img {
    width: 120px;
  }
}
@media (max-width: 1199px) {
  .adminSidebar_sidebar_container__G9HCC {
    max-width: 250px;
  }
}
@media (max-width: 991px) {
  .adminSidebar_sidebar_container__G9HCC {
    max-width: 200px;
  }
  .adminSidebar_sidebar_container__G9HCC .adminSidebar_logo_wrap__sckIl {
    padding: 0 16px 0 5px;
  }
  .adminSidebar_sidebar_container__G9HCC .adminSidebar_logo_wrap__sckIl img {
    width: 69px;
  }
}
@media (max-width: 800px) {
  .adminSidebar_sidebar_container__G9HCC {
    max-width: 160px;
  }
  .adminSidebar_sidebar_container__G9HCC .adminSidebar_logo_wrap__sckIl .adminSidebar_logo_title__3v9zR {
    font-size: 14px;
  }
}

.adminSidebar_close_sidebar__DWiBQ {
  width: 70px;
  transition: width 0.3s ease-in-out;
}
.adminSidebar_close_sidebar__DWiBQ .adminSidebar_logo_wrap__sckIl {
  padding: 5px 0 0;
}
.adminSidebar_close_sidebar__DWiBQ .adminSidebar_logo_wrap__sckIl img {
  width: 69px;
  cursor: pointer;
  transition: width 0.3s ease-in-out;
}
.adminSidebar_close_sidebar__DWiBQ .adminSidebar_logo_wrap__sckIl .adminSidebar_logo_title__3v9zR {
  display: none;
}
@media (max-width: 991px) {
  .adminSidebar_close_sidebar__DWiBQ .adminSidebar_logo_wrap__sckIl {
    padding: 0;
  }
}`, "",{"version":3,"sources":["webpack://./src/app/components/AdminPanel/AdminSidebar/adminSidebar.module.scss"],"names":[],"mappings":"AAAA;EACC,WAAA;EACA,gBAAA;EACA,aAAA;EACA,sCAAA;EACA,kBAAA;EACA,kCAAA;AACD;AACC;EACC,aAAA;AACF;AAEC;EACC,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,eAAA;EACA,gBAAA;EACA,MAAA;EACA,gCAAA;AAAF;AAEE;EACC,YAAA;EACA,gCAAA;EACA,kCAAA;AAAH;AAGE;EACC,gBAAA;EACA,2BAAA;EACA,eAAA;EACA,cAAA;EACA,yBAAA;AADH;AAKC;EACC;IACC,eAAA;EAHD;EAIC;IACC,YAAA;EAFF;AACF;AAMC;EA7CD;IA8CE,gBAAA;EAHA;AACF;AAKC;EAjDD;IAkDE,gBAAA;EAFA;EAIA;IACC,qBAAA;EAFD;EAIC;IACC,WAAA;EAFF;AACF;AAMC;EA7DD;IA8DE,gBAAA;EAHA;EAMC;IACC,eAAA;EAJF;AACF;;AASA;EACC,WAAA;EACA,kCAAA;AAND;AAQC;EACC,gBAAA;AANF;AAOE;EACC,WAAA;EACA,eAAA;EACA,kCAAA;AALH;AAQE;EACC,aAAA;AANH;AAUC;EACC;IACC,UAAA;EARD;AACF","sourcesContent":[".sidebar_container {\n width: 100%;\n max-width: 280px;\n height: 100vh;\n background-color: var(--main-bg-color);\n overflow-y: scroll;\n transition: width 0.3s ease-in-out;\n\n &::-webkit-scrollbar {\n  display: none;\n }\n\n .logo_wrap {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 0 24px;\n  position: sticky;\n  top: 0;\n  background: var(--main-bg-color);\n\n  img {\n   width: 120px;\n   background: var(--main-bg-color);\n   transition: width 0.3s ease-in-out;\n  }\n\n  .logo_title {\n   font-weight: 700;\n   color: var(--primary-color);\n   font-size: 18px;\n   line-height: 1;\n   text-transform: uppercase;\n  }\n }\n\n @media (max-width: 1440px) {\n  .logo_wrap {\n   padding: 0 24px;\n   img {\n    width: 120px;\n   }\n  }\n }\n\n @media (max-width: 1199px) {\n  max-width: 250px;\n }\n\n @media (max-width: 991px) {\n  max-width: 200px;\n\n  .logo_wrap {\n   padding: 0 16px 0 5px;\n\n   img {\n    width: 69px;\n   }\n  }\n }\n\n @media (max-width: 800px) {\n  max-width: 160px;\n\n  .logo_wrap {\n   .logo_title {\n    font-size: 14px;\n   }\n  }\n }\n}\n\n.close_sidebar {\n width: 70px;\n transition: width 0.3s ease-in-out;\n\n .logo_wrap {\n  padding: 5px 0 0;\n  img {\n   width: 69px;\n   cursor: pointer;\n   transition: width 0.3s ease-in-out;\n  }\n\n  .logo_title {\n   display: none;\n  }\n }\n\n @media (max-width: 991px) {\n  .logo_wrap {\n   padding: 0;\n  }\n }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"sidebar_container": `adminSidebar_sidebar_container__G9HCC`,
	"logo_wrap": `adminSidebar_logo_wrap__sckIl`,
	"logo_title": `adminSidebar_logo_title__3v9zR`,
	"close_sidebar": `adminSidebar_close_sidebar__DWiBQ`
};
export default ___CSS_LOADER_EXPORT___;
